import { initClient, type AppRouter } from '@ts-rest/core';
import { getHeaders } from './helpers';
import { getBackendUrl } from './url';

export const generateClient = <T extends AppRouter>(
  router: T,
  withHeaders: boolean = true
) =>
  initClient(router, {
    baseUrl: getBackendUrl(),
    baseHeaders: withHeaders ? getHeaders() : undefined,
    jsonQuery: true,
  });
